<template>
  <div>
    <callout
      v-for="(goal, goalIndex) in model"
      :key="goalIndex"
      class="goal-list"
      :controlled="true"
      :has-border="false"
      has-gradient
      :has-toggle="!!goal.items.length"
      :opened="goal.isCalloutOpen"
      @click:open="() => (goal.isCalloutOpen = !goal.isCalloutOpen)"
    >
      <div class="row align-items-center">
        <div class="col-12 col-md-10 pl-0 py-2">
          <span class="gray-chip">Meta #{{ goalIndex + 1 }}</span>
          <p class="mt-2 pl-1">{{ goal.description }}</p>
        </div>
      </div>
      
      <template #edition>
        <div
          v-if="!!goal.items.length"
          class="objetive__container"
        >
          <div>
            <span class="gray-chip">
              Objetivo(s)
            </span>
          </div>
          <div
            v-for="(item, itemIndex) in goal.items"
            :key="`objective-${itemIndex}`"
            class="my-3"
          >
            <b>{{ `${goalIndex + 1}.${itemIndex + 1}` }}</b>
            {{ `${item.description} ${panelText(item)}` }}

            <div
              v-for="(level, idx) in item.archievements"
              :style="{ 'background-color': level.color, }"
              :key="`level-${idx}`"
            >
              {{ level.periodName }} -
              {{ level.name }}
            </div>
          </div>
        </div>
      </template>
    </callout>
  </div>
</template>

<script>
import Callout from 'custom-callout';

const PERCENT_MEASURE = 2;

export default {
  name: 'PlanGoals',
  components: {
    Callout,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
      model: [],
    };
  },
  watch: {
    value(newValue) {
      this.model = newValue.map(goal => ({
        ...goal,
        isCalloutOpen: false
      }));
    }
  },
  methods: {
    panelText(objetive) {
      return objetive.measureCodeId == PERCENT_MEASURE
        ? `En el ${objetive.measureAmt1}% de las veces.`
        : `En ${objetive.measureAmt1} de ${objetive.measureAmt2} intentos.`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables/_colors.scss';

.goal-list ::v-deep {
  margin: 1rem 0;

  .border--top {
    border-top-width: 0px;
  }

  .gradient-toggle-mob {
    display: none;
  }

  .gradient-toggle {
    display: flex !important;
    box-shadow: none;
    em {
      padding-left: 0.2rem;
      padding-bottom: 3rem;
      &.fa-chevron-circle-right {
        color: map-get($colors, 'primary-1') !important;
      }
    }
  }

  .bg-secondary-3 {
    background-color: map-get($colors, 'white') !important;
  }
  
  .gray-chip {
    background-color: map-get($colors, 'gray-2');
    border-radius: 0.9rem;
    color: white;
    padding: 0.2rem 0.5rem;
  }
    
  .objetive__container {
    padding: 2rem;
    padding-top: 0;
    margin-left: 1rem;
  }

  @media only screen and (max-width: 768px) {
    .goals-action {
      .btn {
        width: 100%;
      }
    }
    
    .gradient-toggle {
      em {
        padding-bottom: 3rem;
      }
    }
  }
}
</style>
